import { RouterModule } from '@angular/router';
import { RealizeOverviewComponent } from './realize-overview.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
const routes = [
    {
        path: '',
        component: RealizeOverviewComponent,
        pathMatch: 'full',
    },
];
export class RealizeOverviewRoutingModule {
}
RealizeOverviewRoutingModule.ɵfac = function RealizeOverviewRoutingModule_Factory(t) { return new (t || RealizeOverviewRoutingModule)(); };
RealizeOverviewRoutingModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RealizeOverviewRoutingModule });
RealizeOverviewRoutingModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[RouterModule.forChild(routes)], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RealizeOverviewRoutingModule, { imports: [i1.RouterModule], exports: [RouterModule] }); })();
